import { useState } from 'react';
import type { Slot, SlotsByDate } from '../../types/booking';

interface SlotPickerProps {
  slots: SlotsByDate[];
  onSelect: (slot: Slot) => void;
}

export default function SlotPicker({ slots, onSelect }: SlotPickerProps) {
  const [selectedDate, setSelectedDate] = useState<string>(slots[0]?.date || '');

  const selectedDaySlots = slots.find((day) => day.date === selectedDate)?.slots || [];

  return (
    <div className="space-y-4">
      {/* Date Tabs */}
      <div className="flex gap-2 overflow-x-auto pb-2">
        {slots.map((day) => {
          const date = new Date(day.date);
          const isSelected = day.date === selectedDate;

          return (
            <button
              key={day.date}
              onClick={() => setSelectedDate(day.date)}
              className={`flex-shrink-0 px-4 py-3 rounded-lg border text-center min-w-[100px] ${
                isSelected
                  ? 'border-primary-600 bg-primary-50 text-primary-700'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
              }`}
            >
              <p className="text-sm font-medium">
                {date.toLocaleDateString('de-DE', { weekday: 'short' })}
              </p>
              <p className="text-lg font-bold">{date.getDate()}</p>
              <p className="text-xs text-gray-500">
                {date.toLocaleDateString('de-DE', { month: 'short' })}
              </p>
            </button>
          );
        })}
      </div>

      {/* Time Slots */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {selectedDaySlots.length === 0 ? (
          <p className="col-span-full text-center text-gray-500 py-4">
            Keine Termine an diesem Tag verfügbar.
          </p>
        ) : (
          selectedDaySlots.map((slot, index) => (
            <button
              key={`${slot.interviewerId}-${slot.start}-${index}`}
              onClick={() => onSelect(slot)}
              className="px-4 py-3 border border-gray-200 rounded-lg hover:border-primary-400 hover:bg-primary-50 text-center transition-colors"
            >
              <p className="font-medium text-gray-900">
                {new Date(slot.start).toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
              <p className="text-xs text-gray-500 truncate">{slot.interviewerName}</p>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
